// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {

    $(document).ready(function () {

        if ($(window).width() >= 768) {
            /* Set the height of the breaker the same of the image inside */
            $("section.breaker").each(function () {
                var bgImage = $(this).children("div.section-background").find("img");
                var section = $(this);

                /* when images load -lazyloaded-, then calculate the height and assign it to container */
                $(bgImage).on('load', function () {
                    section.height(bgImage.height());
                });

                /* also modify the height on resize */
                $(window).on('resize', function () {
                    section.height(bgImage.height());
                });
            });
        }
        else { 
            /*  Adding background color to text area on mobile */
            $("section.background-image").each(function () {
                if ($(this).find("[class*='container']").height() > 45) {

                    var bgColor = $(this).children("div.section-background").css("background-color");
                    $(this).css("background-color", bgColor);
                    switch (bgColor) {
                        case 'rgb(255, 0, 0)':
                            $(this).find("div.arrow").addClass('red');
                            break;
                        case 'rgb(170, 202, 227)':
                            $(this).find("div.arrow").addClass('blue');
                            break;
                        case 'rgb(51, 51, 51)':
                            $(this).find("div.arrow").addClass('dark');
                            break;
                        case 'rgb(240, 240, 240)':
                            $(this).find("div.arrow").addClass('gray1');
                            break;
                        case 'rgb(224, 224, 224)':
                            $(this).find("div.arrow").addClass('gray2');
                            break;
                        case 'rgb(196, 196, 196)':
                            $(this).find("div.arrow").addClass('gray3');
                            break;
                    }
                }
                else {
                    $(this).find("div.arrow").hide();
                }
            });
        }
        /* Replace SVG images with png ONLY for IE8 and below */
        $('.lt-ie9 img[src$=".svg"]').each(function () {
            var src = $(this).attr('src').replace(/.svg/, '.png');
            $(this).attr('src', src);
        });

    });

})(window, document, jQuery);
